<template>
<div class="chapter">
<div class="inner_page">
<p class="lo"><a id="page_i"><img alt="Image" src="images/f000i-01.jpg"/></a></p><a id="page_i">
<p class="break"> </p>
</a><p class="ach"><a id="page_i"></a><a id="page_ii">Also by Julia Gregson</a></p><a id="page_ii">
<p class="acl"><em>East of the Sun</em></p>
<p class="break"> </p>
</a><h1 class="h1"><a id="page_ii"></a><a id="title"></a><a id="page_iii">Band of Angels</a></h1><a id="page_iii">
<p class="im"><img alt="Image" src="images/f0iii-01.jpg"/></p>
<p class="au">J<span class="small">ULIA</span> G<span class="small">REGSON</span></p>
<p class="publisher">A T<span class="small">OUCHSTONE</span> B<span class="small">OOK</span><br/>P<span class="small">UBLISHED BY</span> S<span class="small">IMON</span> &amp; S<span class="small">CHUSTER</span><br/>N<span class="small">EW</span> Y<span class="small">ORK</span> L<span class="small">ONDON</span> T<span class="small">ORONTO</span> S<span class="small">YDNEY</span></p>
<p class="break"> </p>
</a><p class="crlo"><a id="page_iii"></a><a id="copy"></a><a id="page_iv"><img alt="Image" src="images/pub.jpg"/></a></p><a id="page_iv">
<p class="cr">Touchstone</p>
<p class="cr">A Division of Simon &amp; Schuster, Inc.</p>
<p class="cr">1230 Avenue of the Americas</p>
</a><p class="cr"><a id="page_iv">New York, NY 10020<br/><span class="weblink"></span></a><a class="nounder" href="http://www.SimonandSchuster.com" target="_blank">www.SimonandSchuster.com</a></p>
<p class="cr">This book is a work of fiction. Names, characters, places, and incidents either are<br/>products of the author’s imagination or are used fictitiously. Any resemblance to<br/>actual events or locales or persons, living or dead, is entirely coincidental.</p>
<p class="cr">Copyright © 2004 by Julia Gregson</p>
<p class="cr">Originally published in Great Britain in 2004 by Orion, an Hachette Livre<br/>UK company</p>
<p class="cr">All rights reserved, including the right to reproduce this book or portions thereof<br/>in any form whatsoever. For information address Touchstone Subsidiary Rights<br/>Department, 1230 Avenue of the Americas, New York, NY 10020.</p>
<p class="cr">First Touchstone trade paperback edition May 2010</p>
<p class="cr">TOUCHSTONE and colophon are registered trademarks of Simon &amp; Schuster, Inc.</p>
<p class="cr">For information about special discounts for bulk purchases,<br/>please contact Simon &amp; Schuster Special Sales at 1-866-506-1949 or<br/>business@simonandschuster.com.</p>
<p class="cr">The Simon &amp; Schuster Speakers Bureau can bring authors to your live event.<br/>For more information or to book an event contact the Simon &amp; Schuster Speakers Bureau at 1-866-248-3049 or visit our website at <a class="nounder" href="http://www.simonspeakers.com" target="_blank">www.simonspeakers.com</a>.</p>
<p class="cr">Manufactured in the United States of America</p>
<p class="cr">10 9 8 7 6 5 4 3 2 1</p>
<p class="cr">Library of Congress Cataloging-in-Publication Data</p>
<p class="cr">Gregson Julia.</p>
<p class="cr">Band of angels : a novel / Julia Gregson.</p>
<p class="cr">p. cm.</p>
<p class="cr">1. Young Women—England—Fiction. 2. Nurses—Fiction. 3. British—</p>
<p class="cr">Ukraine—Crimea—Fiction. 4. Crimean War, 1853–1856—Fiction. I. Title.</p>
<p class="cr">PR6107.R44494B36 2010</p>
<p class="cr">823’.92—dc22</p>
<p class="cr">2009042198</p>
<p class="cr">ISBN 978-1-4391-0113-1 (pbk)</p>
<p class="cr">ISBN 978-1-4391-1778-1 (ebook)</p>
<p class="break"> </p>
<p class="ded"><a id="dedi"></a><a id="page_v"><em>For Vicki, Richard, Caroline, and Poppy</em></a></p><a id="page_v">
</a><p><a id="page_v"></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001.vue?c20a0aa6